// The content-category vocabulary the parent-facing screens offer.
//
// There used to be TWO hand-maintained lists that didn't match:
//
//   AddChild "What do they love?"  Numbers Letters Colors Shapes
//                                 Animals Music Stories Bedtime
//   Controls "Allowed categories"  Numbers Letters Colors Shapes
//                                 Social  Bedtime Language Creativity
//
// So a parent could pick "Stories" at signup — it was saved to
// Controls.categories and really did filter the child's catalog — and then find
// no Stories chip in Controls, with no way to ever turn it back off. In the
// other direction, Controls offered Animals/Music/Stories… sorry, offered
// Social/Language/Creativity, of which several matched nothing in the catalog.
//
// These names must equal the backend `Category` table (the taxonomy whose
// renames cascade into Video.categories), because category matching is by exact
// string. Keep this list in step with the seed in
// mapa-backend/prisma/migrations/*_seed_default_categories.
export const CONTENT_CATEGORIES = [
  "Numbers",
  "Letters",
  "Colors",
  "Shapes",
  "Social Skills",
  "Language",
  "Creativity",
  "Bedtime",
] as const;

export type ContentCategory = (typeof CONTENT_CATEGORIES)[number];
